export default {
  desktop: {
    LiveThemeImporter: () => import(/* webpackChunkName: "satibet-themeWrapLive" */'./LiveThemeImporter'),
  },
  mobile: {
    LiveThemeImporter: () => import(/* webpackChunkName: "satibet-themeWrapLive" */'./LiveThemeImporter'),
  },
};
